import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Pagination from '@mui/material/Pagination';
import { NavLink } from 'react-router-dom';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import BreadcrumbsWrapper from '../../../components/breadcrumbs';
import { postRequest, patchRequest, deleteRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import { useContext, useEffect, useRef, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Swal from 'sweetalert2';
import Tooltip from '@mui/material/Tooltip';


import TablePagination from '@mui/material/TablePagination';


import Select from '@mui/material/Select';
import AddIcon from '@mui/icons-material/Add';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
    'Omar Alexander',
    'Carlos Abbott',
    'Miriam Wagner',
    'Bradley Wilkerson',
    'Virginia Andrews',
    'Kelly Snyder',
];
export default function Automations() {
  const [isActive, setIsActive] = useState(false);

  const handleToggle = () => {
    setIsActive(prev => !prev);
  };

    const [pages, setPages] = React.useState(2);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [automationList, setAutomationList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    // Search states
    const [searchFields, setSearchFields] = useState({
        name: '',
        triggerType: '',
        effectType: '',
        isActive: undefined,
    });

    const authCtx = useContext(AuthContext);
    const debounceRef = useRef();
    
    // Group automations by product
    const [groupedAutomations, setGroupedAutomations] = useState({
      allProducts: [],
      will: [],
      conveyancing: [],
      lssWill: [],
      lssLastingPowers: [],
      lssEstate: [],
      lssGrant: [],
      lastingPowers: []
    });

    // Fetch automations
    const fetchAutomations = async (payloadFields = searchFields, pageVal = page) => {
        const payload = {
            ...payloadFields,
            page: pageVal,
            limit: 50, // Get more automations to show across all sections
        };

        setLoading(true);
        try {
            const response = await postRequest('automationList', payload, authCtx.token);
            if (response?.data) {
                const automations = response.data.docs || [];
                
                // Remove any duplicate automations based on ID
                const uniqueAutomations = automations.filter((automation, index, self) =>
                    index === self.findIndex((a) => a._id === automation._id)
                );
                
                console.log(`📊 Received ${automations.length} automations, ${uniqueAutomations.length} unique`);
                
                setAutomationList(uniqueAutomations);
                setTotalPages(response.data.totalPages || 1);
                
                // Group automations by product
                const grouped = {
                  allProducts: [],
                  will: [],
                  conveyancing: [],
                  lssWill: [],
                  lssLastingPowers: [],
                  lssEstate: [],
                  lssGrant: [],
                  lastingPowers: []
                };
                
                // Process each automation
                uniqueAutomations.forEach(automation => {
                  console.log('🔍 Processing automation:', automation.name);
                  console.log('📧 Email Template ID:', automation.effect?.emailTemplateId);
                  console.log('📧 Email Template Type:', typeof automation.effect?.emailTemplateId);
                  if (automation.effect?.emailTemplateId && typeof automation.effect.emailTemplateId === 'object') {
                    console.log('📧 Email Template Name:', automation.effect.emailTemplateId.name || automation.effect.emailTemplateId.title);
                  }
                  console.log('📄 Effect Type:', automation.effect?.type);

                  // Track which categories this automation has been added to
                  const addedToCategories = new Set();
                  
                  // If no products specified or empty array, it's for all products
                  if (!automation.products || automation.products.length === 0) {
                    console.log('➡️ Adding to All Products:', automation.name);
                    grouped.allProducts.push(automation);
                  } else {
                    // Group by specific products
                    automation.products.forEach(product => {
                      const productTitle = product.title?.toLowerCase() || '';
                      console.log('🏷️ Product title:', productTitle);
                      
                      let category = null;
                      
                      if (productTitle.includes('will') && !productTitle.includes('lss')) {
                        category = 'will';
                      } else if (productTitle.includes('conveyancing')) {
                        // For conveyancing, always use the same category regardless of specific product
                        category = 'conveyancing';
                      } else if (productTitle.includes('lss') && productTitle.includes('will')) {
                        category = 'lssWill';
                      } else if (productTitle.includes('lss') && productTitle.includes('lasting powers')) {
                        category = 'lssLastingPowers';
                      } else if (productTitle.includes('lss') && productTitle.includes('estate')) {
                        category = 'lssEstate';
                      } else if (productTitle.includes('lss') && productTitle.includes('grant')) {
                        category = 'lssGrant';
                      } else if (productTitle.includes('lasting powers')) {
                        category = 'lastingPowers';
                      } else {
                        category = 'allProducts';
                      }
                      
                      // Only add if not already added to this category
                      if (category && !addedToCategories.has(category)) {
                        console.log(`➡️ Adding to ${category}:`, automation.name);
                        grouped[category].push(automation);
                        addedToCategories.add(category);
                      } else if (addedToCategories.has(category)) {
                        console.log(`⚠️ Skipping duplicate addition to ${category} for product ${productTitle}:`, automation.name);
                      }
                    });
                  }
                });
                
                setGroupedAutomations(grouped);
            } else {
                setAutomationList([]);
                setTotalPages(1);
            }
        } catch (err) {
            console.error('Error fetching automations:', err);
            setAutomationList([]);
            setTotalPages(1);
        } finally {
            setLoading(false);
        }
    };

    // On initial load and page change
    useEffect(() => {
        fetchAutomations(searchFields, page);
        // eslint-disable-next-line
    }, [page]);

    // Debounced search on fields change
    useEffect(() => {
        setPage(1);
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            fetchAutomations(searchFields, 1);
        }, 400);
        // eslint-disable-next-line
    }, [searchFields]);

    // Handle individual search input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchFields((prev) => ({ ...prev, [name]: value }));
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const handleDeleteAutomation = async (automationId) => {
        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you really want to delete this automation?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        });

        if (confirm.isConfirmed) {
            try {
                const response = await deleteRequest(`deleteAutomation/${automationId}`, {});
                if (response?.status === 'success' || response?.status === 200) {
                    Swal.fire('Deleted!', 'Automation has been deleted.', 'success');
                    fetchAutomations(searchFields, page);
                } else {
                    Swal.fire('Error', response?.message || 'Failed to delete automation', 'error');
                }
            } catch (err) {
                Swal.fire('Error', err?.message || 'Failed to delete automation', 'error');
            }
        }
    };
    
    const handleToggleAutomation = async (automationId) => {
        try {
            const response = await patchRequest(`toggleAutomationStatus/${automationId}`, {});
            if (response?.status === 'success') {
                fetchAutomations(searchFields, page);
            } else {
                Swal.fire('Error', response?.message || 'Failed to toggle automation status', 'error');
            }
        } catch (err) {
            Swal.fire('Error', err?.message || 'Failed to toggle automation status', 'error');
        }
    };

    const [age, setAge] = React.useState('');
    const [status, setStatus] = React.useState('');

    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const handleChange1 = (event) => {
        setStatus(event.target.value);
    };



    const [personName, setPersonName] = React.useState([]);

    const handleChange2 = (event) => {
        const {
            target: { value },
        } = event;
        setPersonName(typeof value === 'string' ? value.split(',') : value);
    };
    
    // Helper function to format run time
    const formatRunTime = (automation) => {
        if (!automation.runConfig || automation.runConfig.type === 'Immediately') {
            return 'Immediately';
        }
        const num = automation.runConfig.scheduleNumber || 0;
        const unit = automation.runConfig.scheduleUnit || 'Hours';
        return `${num} ${unit}`;
    };
    
    // Helper function to format automation action display
    const formatActionDisplay = (automation) => {
        if (!automation.effect || !automation.effect.type) {
            return 'No action defined';
        }
        let display = automation.effect.type;

        // Handle email template name display
        if (automation.effect.emailTemplateId) {
            console.log('🎨 Formatting action for:', automation.name);
            console.log('🎨 Email Template ID:', automation.effect.emailTemplateId);
            console.log('🎨 Is Object?', typeof automation.effect.emailTemplateId === 'object');

            let templateName = '';
            if (typeof automation.effect.emailTemplateId === 'object' && automation.effect.emailTemplateId !== null) {
                templateName = automation.effect.emailTemplateId.name || automation.effect.emailTemplateId.title || '';
                console.log('🎨 Extracted Template Name:', templateName);
            }
            if (templateName) {
                display += ` (${templateName})`;
                console.log('🎨 Final Display:', display);
            }
        }

        // Handle SMS template name display
        if (automation.effect.smsTemplateId) {
            let templateName = '';
            if (typeof automation.effect.smsTemplateId === 'object' && automation.effect.smsTemplateId !== null) {
                templateName = automation.effect.smsTemplateId.name || automation.effect.smsTemplateId.title || '';
            }
            if (templateName) {
                display += ` (${templateName})`;
            }
        }

        // Handle status change display
        if (automation.effect.newStatus) {
            display += ` (${automation.effect.newStatus})`;
        }

        return display;
    };

    // Helper function to group automations by trigger
    const groupByTrigger = (automations) => {
        const grouped = {};
        automations.forEach(automation => {
            const triggerType = automation.trigger.type;
            if (!grouped[triggerType]) {
                grouped[triggerType] = [];
            }
            grouped[triggerType].push(automation);
        });
        return grouped;
    };
    return (
        <>
            <BreadcrumbsWrapper
                items={[
                    { label: 'Dashboard', path: '/dashboard' },
                    { label: 'Automation', path: '' },
                ]}
            />
            <br />
            
            <div className='page-header pb-3'>
                <h1 className='mt-0 mb-0'>Automation</h1>
                {/* <div className='header-right-btn'>
          <Stack spacing={2} direction="row">
            <Button variant="outlined" className='red-outline-btn text-capitalize'>
              <NavLink to="/customers/create" className="red-link-text">
                <SearchIcon /> &nbsp; Search Customers
              </NavLink>
            </Button>
            <Button variant="outlined" className='red-outline-btn text-capitalize'>
              <NavLink to="/customers/create" className="red-link-text">
                <PersonAddOutlinedIcon /> &nbsp; Create Customer
              </NavLink>
            </Button>
          </Stack>
        </div> */}
            </div>

            {/* Search Form */}
            <div className='page-top-formview mb-3'>

                <div className='customer-tab-view'>
                    <Table  responsive bordered component="div"
                        count={100}
                        page={page}
                    >
                        <thead>
                            <tr>
                                <th colSpan={3} className='bg-grey' style={{ verticalAlign: "middle" }}>All Products</th>
                                <th className='bg-grey text-end'><Button variant="outlined" className='red-outline-btn text-capitalize'>
                                    <NavLink to="/automation/create/allproducts" className="red-link-text">
                                        <AddIcon /> &nbsp;  Add Automation
                                    </NavLink>
                                </Button></th>
                            </tr>
                            <tr>
                                <th>Trigger</th>
                                <th>Action</th>
                                <th>Run</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        <CircularProgress size={30} />
                                    </td>
                                </tr>
                            ) : groupedAutomations.allProducts.length > 0 ? (
                                (() => {
                                    const grouped = groupByTrigger(groupedAutomations.allProducts);
                                    const rows = [];
                                    Object.keys(grouped).forEach(triggerType => {
                                        const automations = grouped[triggerType];
                                        automations.forEach((automation, actionIndex) => {
                                            rows.push(
                                                <tr key={automation._id}>
                                                    {actionIndex === 0 && (
                                                        <td rowSpan={automations.length} style={{ verticalAlign: 'middle' }}>
                                                            {triggerType}
                                                        </td>
                                                    )}
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        <FiberManualRecordIcon /> &nbsp; {formatActionDisplay(automation)}
                                                    </td>
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        {formatRunTime(automation)}
                                                    </td>
                                                    <td>
                                                        <Tooltip title="Delete">
                                                            <span
                                                                className="red-link-text cursor-pointer"
                                                                onClick={() => handleDeleteAutomation(automation._id)}
                                                            >
                                                                <DeleteOutlineOutlinedIcon />
                                                            </span>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <Tooltip title="Edit">
                                                            <NavLink
                                                                to={`/automation/edit/${automation._id}/allproducts`}
                                                                className="red-link-text"
                                                            >
                                                                <EditOutlinedIcon />
                                                            </NavLink>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <span
                                                            className='red-link-text cursor-pointer w-18'
                                                            title={automation.isActive ? "Deactivate" : "Activate"}
                                                            onClick={() => handleToggleAutomation(automation._id)}
                                                        >
                                                            {automation.isActive ? 'Deactivate' : 'Activate'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        });
                                    });
                                    return rows;
                                })()
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">No automations found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                </div>
                <div className='customer-tab-view'>
                    <Table  responsive bordered component="div"
                        count={100}
                        page={page}
                    >
                        <thead>
                            <tr>
                                <th colSpan={3} className='bg-grey' style={{ verticalAlign: "middle" }}>Will</th>
                                <th className='bg-grey text-end'><Button variant="outlined" className='red-outline-btn text-capitalize'>
                                    <NavLink to="/automation/create/will" className="red-link-text">
                                        <AddIcon /> &nbsp;  Add Automation
                                    </NavLink>
                                </Button></th>
                            </tr>
                            <tr>
                                <th>Trigger</th>
                                <th>Action</th>
                                <th>Run</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        <CircularProgress size={30} />
                                    </td>
                                </tr>
                            ) : groupedAutomations.will.length > 0 ? (
                                (() => {
                                    const grouped = groupByTrigger(groupedAutomations.will);
                                    const rows = [];
                                    Object.keys(grouped).forEach(triggerType => {
                                        const automations = grouped[triggerType];
                                        automations.forEach((automation, actionIndex) => {
                                            rows.push(
                                                <tr key={automation._id}>
                                                    {actionIndex === 0 && (
                                                        <td rowSpan={automations.length} style={{ verticalAlign: 'middle' }}>
                                                            {triggerType}
                                                        </td>
                                                    )}
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        <FiberManualRecordIcon /> &nbsp; {formatActionDisplay(automation)}
                                                    </td>
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        {formatRunTime(automation)}
                                                    </td>
                                                    <td>
                                                        <Tooltip title="Delete">
                                                            <span
                                                                className="red-link-text cursor-pointer"
                                                                onClick={() => handleDeleteAutomation(automation._id)}
                                                            >
                                                                <DeleteOutlineOutlinedIcon />
                                                            </span>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <Tooltip title="Edit">
                                                            <NavLink
                                                                to={`/automation/edit/${automation._id}/will`}
                                                                className="red-link-text"
                                                            >
                                                                <EditOutlinedIcon />
                                                            </NavLink>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <span
                                                            className='red-link-text cursor-pointer w-18'
                                                            title={automation.isActive ? "Deactivate" : "Activate"}
                                                            onClick={() => handleToggleAutomation(automation._id)}
                                                        >
                                                            {automation.isActive ? 'Deactivate' : 'Activate'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        });
                                    });
                                    return rows;
                                })()
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">No automations found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                </div>
                <div className='customer-tab-view'>
                    <Table  responsive bordered component="div"
                        count={100}
                        page={page}
                    >
                        <thead>
                            <tr>
                                <th colSpan={3} className='bg-grey' style={{ verticalAlign: "middle" }}>Conveyancing</th>
                                <th className='bg-grey text-end'><Button variant="outlined" className='red-outline-btn text-capitalize'>
                                    <NavLink to="/automation/create/conveyancing" className="red-link-text">
                                        <AddIcon /> &nbsp;  Add Automation
                                    </NavLink>
                                </Button></th>
                            </tr>
                            <tr>
                                <th>Trigger</th>
                                <th>Action</th>
                                <th>Run</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        <CircularProgress size={30} />
                                    </td>
                                </tr>
                            ) : groupedAutomations.conveyancing.length > 0 ? (
                                (() => {
                                    const grouped = groupByTrigger(groupedAutomations.conveyancing);
                                    const rows = [];
                                    Object.keys(grouped).forEach(triggerType => {
                                        const automations = grouped[triggerType];
                                        automations.forEach((automation, actionIndex) => {
                                            rows.push(
                                                <tr key={automation._id}>
                                                    {actionIndex === 0 && (
                                                        <td rowSpan={automations.length} style={{ verticalAlign: 'middle' }}>
                                                            {triggerType}
                                                        </td>
                                                    )}
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        <FiberManualRecordIcon /> &nbsp; {formatActionDisplay(automation)}
                                                    </td>
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        {formatRunTime(automation)}
                                                    </td>
                                                    <td>
                                                        <Tooltip title="Delete">
                                                            <span
                                                                className="red-link-text cursor-pointer"
                                                                onClick={() => handleDeleteAutomation(automation._id)}
                                                            >
                                                                <DeleteOutlineOutlinedIcon />
                                                            </span>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <Tooltip title="Edit">
                                                            <NavLink
                                                                to={`/automation/edit/${automation._id}/conveyancing`}
                                                                className="red-link-text"
                                                            >
                                                                <EditOutlinedIcon />
                                                            </NavLink>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <span
                                                            className='red-link-text cursor-pointer w-18'
                                                            title={automation.isActive ? "Deactivate" : "Activate"}
                                                            onClick={() => handleToggleAutomation(automation._id)}
                                                        >
                                                            {automation.isActive ? 'Deactivate' : 'Activate'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        });
                                    });
                                    return rows;
                                })()
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">No automations found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                </div>
                <div className='customer-tab-view'>
                    <Table  responsive bordered component="div"
                        count={100}
                        page={page}
                    >
                        <thead>
                            <tr>
                                <th colSpan={3} className='bg-grey' style={{ verticalAlign: "middle" }}>LSS Will</th>
                                <th className='bg-grey text-end'><Button variant="outlined" className='red-outline-btn text-capitalize'>
                                    <NavLink to="/automation/create/lsswill" className="red-link-text">
                                        <AddIcon /> &nbsp;  Add Automation
                                    </NavLink>
                                </Button></th>
                            </tr>
                            <tr>
                                <th>Trigger</th>
                                <th>Action</th>
                                <th>Run</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        <CircularProgress size={30} />
                                    </td>
                                </tr>
                            ) : groupedAutomations.lssWill.length > 0 ? (
                                (() => {
                                    const grouped = groupByTrigger(groupedAutomations.lssWill);
                                    const rows = [];
                                    Object.keys(grouped).forEach(triggerType => {
                                        const automations = grouped[triggerType];
                                        automations.forEach((automation, actionIndex) => {
                                            rows.push(
                                                <tr key={automation._id}>
                                                    {actionIndex === 0 && (
                                                        <td rowSpan={automations.length} style={{ verticalAlign: 'middle' }}>
                                                            {triggerType}
                                                        </td>
                                                    )}
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        <FiberManualRecordIcon /> &nbsp; {formatActionDisplay(automation)}
                                                    </td>
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        {formatRunTime(automation)}
                                                    </td>
                                                    <td>
                                                        <Tooltip title="Delete">
                                                            <span
                                                                className="red-link-text cursor-pointer"
                                                                onClick={() => handleDeleteAutomation(automation._id)}
                                                            >
                                                                <DeleteOutlineOutlinedIcon />
                                                            </span>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <Tooltip title="Edit">
                                                            <NavLink
                                                                to={`/automation/edit/${automation._id}/lsswill`}
                                                                className="red-link-text"
                                                            >
                                                                <EditOutlinedIcon />
                                                            </NavLink>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <span
                                                            className='red-link-text cursor-pointer w-18'
                                                            title={automation.isActive ? "Deactivate" : "Activate"}
                                                            onClick={() => handleToggleAutomation(automation._id)}
                                                        >
                                                            {automation.isActive ? 'Deactivate' : 'Activate'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        });
                                    });
                                    return rows;
                                })()
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">No automations found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                </div>
                <div className='customer-tab-view'>
                    <Table  responsive bordered component="div"
                        count={100}
                        page={page}
                    >
                        <thead>
                            <tr>
                                <th colSpan={3} className='bg-grey' style={{ verticalAlign: "middle" }}>LSS Lasting Powers of Attorney</th>
                                <th className='bg-grey text-end'><Button variant="outlined" className='red-outline-btn text-capitalize'>
                                    <NavLink to="/automation/create/lsslastingpowers" className="red-link-text">
                                        <AddIcon /> &nbsp;  Add Automation
                                    </NavLink>
                                </Button></th>
                            </tr>
                            <tr>
                                <th>Trigger</th>
                                <th>Action</th>
                                <th>Run</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        <CircularProgress size={30} />
                                    </td>
                                </tr>
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">No automations found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                </div>
                <div className='customer-tab-view'>
                    <Table  responsive bordered component="div"
                        count={100}
                        page={page}
                    >
                        <thead>
                            <tr>
                                <th colSpan={3} className='bg-grey' style={{ verticalAlign: "middle" }}>LSS Estate Administration</th>
                                <th className='bg-grey text-end'><Button variant="outlined" className='red-outline-btn text-capitalize'>
                                    <NavLink to="/automation/create/lssestate" className="red-link-text">
                                        <AddIcon /> &nbsp;  Add Automation
                                    </NavLink>
                                </Button></th>
                            </tr>
                            <tr>
                                <th>Trigger</th>
                                <th>Action</th>
                                <th>Run</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        <CircularProgress size={30} />
                                    </td>
                                </tr>
                            ) : groupedAutomations.lssEstate.length > 0 ? (
                                (() => {
                                    const grouped = groupByTrigger(groupedAutomations.lssEstate);
                                    const rows = [];
                                    Object.keys(grouped).forEach(triggerType => {
                                        const automations = grouped[triggerType];
                                        automations.forEach((automation, actionIndex) => {
                                            rows.push(
                                                <tr key={automation._id}>
                                                    {actionIndex === 0 && (
                                                        <td rowSpan={automations.length} style={{ verticalAlign: 'middle' }}>
                                                            {triggerType}
                                                        </td>
                                                    )}
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        <FiberManualRecordIcon /> &nbsp; {formatActionDisplay(automation)}
                                                    </td>
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        {formatRunTime(automation)}
                                                    </td>
                                                    <td>
                                                        <Tooltip title="Delete">
                                                            <span
                                                                className="red-link-text cursor-pointer"
                                                                onClick={() => handleDeleteAutomation(automation._id)}
                                                            >
                                                                <DeleteOutlineOutlinedIcon />
                                                            </span>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <Tooltip title="Edit">
                                                            <NavLink
                                                                to={`/automation/edit/${automation._id}/lssestate`}
                                                                className="red-link-text"
                                                            >
                                                                <EditOutlinedIcon />
                                                            </NavLink>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <span
                                                            className='red-link-text cursor-pointer w-18'
                                                            title={automation.isActive ? "Deactivate" : "Activate"}
                                                            onClick={() => handleToggleAutomation(automation._id)}
                                                        >
                                                            {automation.isActive ? 'Deactivate' : 'Activate'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        });
                                    });
                                    return rows;
                                })()
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">No automations found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                </div>
                <div className='customer-tab-view'>
                    <Table  responsive bordered component="div"
                        count={100}
                        page={page}
                    >
                        <thead>
                            <tr>
                                <th colSpan={3} className='bg-grey' style={{ verticalAlign: "middle" }}>LSS Grant Application</th>
                                <th className='bg-grey text-end'><Button variant="outlined" className='red-outline-btn text-capitalize'>
                                    <NavLink to="/automation/create/lssgrant" className="red-link-text">
                                        <AddIcon /> &nbsp;  Add Automation
                                    </NavLink>
                                </Button></th>
                            </tr>
                            <tr>
                                <th>Trigger</th>
                                <th>Action</th>
                                <th>Run</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        <CircularProgress size={30} />
                                    </td>
                                </tr>
                            ) : groupedAutomations.lssGrant.length > 0 ? (
                                (() => {
                                    const grouped = groupByTrigger(groupedAutomations.lssGrant);
                                    const rows = [];
                                    Object.keys(grouped).forEach(triggerType => {
                                        const automations = grouped[triggerType];
                                        automations.forEach((automation, actionIndex) => {
                                            rows.push(
                                                <tr key={automation._id}>
                                                    {actionIndex === 0 && (
                                                        <td rowSpan={automations.length} style={{ verticalAlign: 'middle' }}>
                                                            {triggerType}
                                                        </td>
                                                    )}
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        <FiberManualRecordIcon /> &nbsp; {formatActionDisplay(automation)}
                                                    </td>
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        {formatRunTime(automation)}
                                                    </td>
                                                    <td>
                                                        <Tooltip title="Delete">
                                                            <span
                                                                className="red-link-text cursor-pointer"
                                                                onClick={() => handleDeleteAutomation(automation._id)}
                                                            >
                                                                <DeleteOutlineOutlinedIcon />
                                                            </span>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <Tooltip title="Edit">
                                                            <NavLink
                                                                to={`/automation/edit/${automation._id}/lssgrant`}
                                                                className="red-link-text"
                                                            >
                                                                <EditOutlinedIcon />
                                                            </NavLink>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <span
                                                            className='red-link-text cursor-pointer w-18'
                                                            title={automation.isActive ? "Deactivate" : "Activate"}
                                                            onClick={() => handleToggleAutomation(automation._id)}
                                                        >
                                                            {automation.isActive ? 'Deactivate' : 'Activate'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        });
                                    });
                                    return rows;
                                })()
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">No automations found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                </div>
                <div className='customer-tab-view'>
                    <Table  responsive bordered component="div"
                        count={100}
                        page={page}
                    >
                        <thead>
                            <tr>
                                <th colSpan={3} className='bg-grey' style={{ verticalAlign: "middle" }}>Lasting Powers of Attorney</th>
                                <th className='bg-grey text-end'><Button variant="outlined" className='red-outline-btn text-capitalize'>
                                    <NavLink to="/automation/create/lastingpowers" className="red-link-text">
                                        <AddIcon /> &nbsp;  Add Automation
                                    </NavLink>
                                </Button></th>
                            </tr>
                            <tr>
                                <th>Trigger</th>
                                <th>Action</th>
                                <th>Run</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="4" className="text-center">
                                        <CircularProgress size={30} />
                                    </td>
                                </tr>
                            ) : groupedAutomations.lastingPowers.length > 0 ? (
                                (() => {
                                    const grouped = groupByTrigger(groupedAutomations.lastingPowers);
                                    const rows = [];
                                    Object.keys(grouped).forEach(triggerType => {
                                        const automations = grouped[triggerType];
                                        automations.forEach((automation, actionIndex) => {
                                            rows.push(
                                                <tr key={automation._id}>
                                                    {actionIndex === 0 && (
                                                        <td rowSpan={automations.length} style={{ verticalAlign: 'middle' }}>
                                                            {triggerType}
                                                        </td>
                                                    )}
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        <FiberManualRecordIcon /> &nbsp; {formatActionDisplay(automation)}
                                                    </td>
                                                    <td className={automation.isActive ? 'active-automation' : 'inactive-automation'}>
                                                        {formatRunTime(automation)}
                                                    </td>
                                                    <td>
                                                        <Tooltip title="Delete">
                                                            <span
                                                                className="red-link-text cursor-pointer"
                                                                onClick={() => handleDeleteAutomation(automation._id)}
                                                            >
                                                                <DeleteOutlineOutlinedIcon />
                                                            </span>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <Tooltip title="Edit">
                                                            <NavLink
                                                                to={`/automation/edit/${automation._id}/lastingpowers`}
                                                                className="red-link-text"
                                                            >
                                                                <EditOutlinedIcon />
                                                            </NavLink>
                                                        </Tooltip>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <span
                                                            className='red-link-text cursor-pointer w-18'
                                                            title={automation.isActive ? "Deactivate" : "Activate"}
                                                            onClick={() => handleToggleAutomation(automation._id)}
                                                        >
                                                            {automation.isActive ? 'Deactivate' : 'Activate'}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        });
                                    });
                                    return rows;
                                })()
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center">No automations found</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                </div>


            </div>

            {/* Table View */}
            <div>
                {/* Removed pagination since we're showing all automations grouped by product */}
            </div>
        </>
    );
}
